import React from 'react';

export function Sidebar({ items, active, onChange }) {
  const main = items.filter(i => i.section !== 'account');
  const acct = items.filter(i => i.section === 'account');

  return (
    <nav className="sidebar">
      <div className="sidebar-section">Main</div>
      {main.map(item => (
        <div
          key={item.id}
          className={`sidebar-item${active === item.id ? ' active' : ''}`}
          onClick={() => onChange(item.id)}
        >
          <span className="sidebar-icon">{item.icon}</span>
          {item.label}
          {item.badge ? <span className="sidebar-badge">{item.badge}</span> : null}
        </div>
      ))}
      {acct.length > 0 && (
        <>
          <hr className="sbar" />
          <div className="sidebar-section">Account</div>
          {acct.map(item => (
            <div
              key={item.id}
              className={`sidebar-item${active === item.id ? ' active' : ''}`}
              onClick={() => onChange(item.id)}
            >
              <span className="sidebar-icon">{item.icon}</span>
              {item.label}
            </div>
          ))}
        </>
      )}
    </nav>
  );
}
